import React, {PureComponent} from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import Copyright from '../../common/components/layout/Copyright';

class LegalComp extends PureComponent {
  render() {
    return (
      <Container className="container-full legal-container">
        <Row className="legal-row">
          <Col xs={{span: 12, order: 2}} md={{span: 3, order: 1}} className="rights">
            <div className="copyright">
              <Copyright/>
            </div>
          </Col>
          <Col xs={{span: 12, order: 1}} md={{span: 9, order: 2}} className="legal-col">
            <Row className="tablet-grid">
              <Col xs={2} md={3} className="legal-comp"><Link to={'/cgu'}>CGU</Link></Col>
              <Col xs={2} md={3} className="legal-comp"><Link to={'/privacy'}>Politique de confidentialité</Link></Col>
              <Col xs={2} md={3} className="legal-comp"><Link to={'/legal-notice'}>Mentions légales</Link></Col>
              {/*<Col xs={2} md={3} className="legal-comp">CGV</Col>*/}
              {/*<Col xs={2} md={3} className="legal-comp">Contact</Col>*/}
            </Row>
            <Row className="desktop-grid">
              <Col md={12} className="legal-col">
                {/*<div className="legal-content">Mentions légales</div>*/}
                <div className="legal-content"><Link to={'/cgu'}>CGU</Link></div>
                <div className="legal-content"><Link to={'/privacy'}>Politique de confidentialité</Link></div>
                <div className="legal-content"><Link to={'/legal-notice'}>Mentions légales</Link></div>
                {/*<div className="legal-content">CGV</div>*/}
                {/*<div className="legal-content">Contact</div>*/}
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default LegalComp;
